import client from '../client';

import { GET_TEMPLATE } from 'graphql/queries/template';
import { TEMPLATE_PUBLIC } from '../fragments/templates';

export const updateTemplatePublic = (template: Template): void => {
  const isPublic = !template.isPublic;

  client.writeFragment({
    fragment: TEMPLATE_PUBLIC,
    id: `Template:${template._id}`,
    data: {
      isPublic,
      __typename: 'Template',
    },
  });
};

export const updateTemplateCache = (template: Template) => {
  const cachedTemplate = client.readQuery<Template>({
    query: GET_TEMPLATE,
    variables: { templateId: template._id },
  });

  if (!!cachedTemplate) {
    client.writeQuery({
      query: GET_TEMPLATE,
      variables: { templateId: template._id },
      data: {
        template,
      },
    });
  }
};
